import { useState } from 'react';
import { useAuthStore } from '@/store/authStore';
import { RequestDemoModal } from './RequestDemoModal';

export function LoggedOutPage() {
  const login = useAuthStore((s) => s.login);
  const [demoOpen, setDemoOpen] = useState(false);
  return (
    <div className="h-dvh grid place-items-center bg-[var(--bg-base)] text-[var(--fg-primary)] overflow-hidden relative">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-50"
        style={{
          background:
            'radial-gradient(circle at 50% 38%, rgba(99,102,241,0.15) 0%, rgba(99,102,241,0) 55%)',
        }}
      />
      <div className="relative text-center space-y-5 px-6 max-w-md">
        <img
          src="/phos-logo.png"
          alt="Phos Intelligence"
          width={80}
          height={80}
          className="mx-auto select-none opacity-70"
        />
        <div className="space-y-1">
          <h1 className="font-display font-semibold text-xl tracking-tight">Signed out</h1>
          <p className="text-sm text-[var(--fg-muted)]">
            Your session has ended. Click below to sign in again.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2">
          <button
            onClick={() => login(true)}
            className="px-5 py-2 rounded-md bg-[var(--accent-brand)] hover:bg-[var(--accent-brand-hover)] text-white font-medium text-sm transition-colors w-full sm:w-auto"
          >
            Sign in again
          </button>
          <button
            onClick={() => setDemoOpen(true)}
            className="px-5 py-2 rounded-md border border-[var(--border-strong)] hover:border-[var(--accent-brand)] text-[var(--fg-muted)] hover:text-[var(--fg-primary)] hover:bg-[var(--bg-elevated)] font-medium text-sm transition-colors w-full sm:w-auto"
          >
            Request a Demo
          </button>
        </div>
        <p className="text-[11px] text-[var(--fg-faint)]">
          New to Phos Intelligence? Click <em>Request a Demo</em> and we{"'"}ll get back to you.
        </p>
      </div>
      <RequestDemoModal open={demoOpen} onClose={() => setDemoOpen(false)} />
    </div>
  );
}
